import React from "react"
import Contact from "../shared/top/Contact"

const TopContact = () => {
  return <Contact target="nico" tel="0278-25-4970" />
}

export default TopContact
